import * as React from "react";
import { ButtonToolbar } from "react-bootstrap";

interface ButtonGroupProps {}

export const ButtonGroup: React.FC<ButtonGroupProps> = (props) => {
    return <ButtonToolbar>{props.children}</ButtonToolbar>;
};
